<template>
  <div class="login">
    <b-col v-if="showLogin" class="box" md="6" offset-md="3">
      <div style="margin-top: -10px;">
        <b-row>
            <b-col cols="3" />
            <b-col cols="6" class="d-flex justify-content-center" style="margin-bottom:25px; align-items: center">
              <b-row>
                <b-col cols="4">
                  <img
                    class="mx-auto d-block"
                    :src="'/static/images/unpd/unpd_logo_color_' + $i18n.locale + '.svg'"
                    height="170"
                    style="margin: -10px -10px 0 0"
                    />
                </b-col>
                <b-col cols="4">
                  <img
                    class="mx-auto d-block indica-logo"
                    :src="'../static/images/GES_Logo' + '.svg'"
                    alt="Indic@"
                    height="150"
                  />
                </b-col>
              </b-row>
            </b-col>
          <div cols="3" class="ml-auto p-2">
            <b-navbar-nav class="language-selector">
              <template-language-selector :showLangLabel="true"/>
            </b-navbar-nav>
          </div>
        </b-row>
        <h3>{{ $t("label_login_title") }}</h3>
        <p class="legend">
          {{ $t("label_login_title_caption") }}
        </p>
      </div>
      <b-form @submit.prevent="login">
        <b-form-group
          id="username"
          :label="$t('label_login_username')"
          label-for="username"
        >
          <b-input-group>
            <div class="input-group-addon">
              <icon style="fill: white" name="user" scale="1.5" />
            </div>
            <b-input id="username" v-model="username" type="text" />
          </b-input-group>
        </b-form-group>
        <b-form-group
          id="password"
          :label="$t('label_login_password')"
          label-for="password"
        >
          <b-input-group>
            <div class="input-group-addon">
              <icon style="fill: white" name="lock" scale="1.5" />
            </div>
            <b-input id="password" v-model="password" type="password" />
          </b-input-group>
        </b-form-group>
        <p>{{ error }}</p>
        <b-button type="submit" variant="primary" block>
          {{ $t("label_login_button") }}
        </b-button>
        <p class="forgot" @click="toggleShowLogin">
          {{ $t("label_login_forgotPassword_caption") }}
        </p>
      </b-form>
    </b-col>
    <b-col v-if="!showLogin" class="box" md="6" offset-md="3">
      <h3>{{ $t("label_login_recoverPassword_title") }}</h3>
      <p class="legend">
        {{ $t("label_login_recoverPassword_title_caption") }}s
      </p>
      <b-form @submit.prevent="login">
        <b-form-group
          id="username"
          :label="$t('label_login_recoverPassword_username')"
          label-for="username"
        >
          <b-input-group>
            <div class="input-group-addon">
              <icon style="fill: white" name="user" scale="1.5" />
            </div>
            <b-input id="username" v-model="usernameRecovery" type="text" />
          </b-input-group>
        </b-form-group>
        <p>{{ error }}</p>
        <b-button type="submit" variant="primary" block>
          {{ $t("label_login_recoverPassword_button") }}
        </b-button>
        <p class="forgot" @click="toggleShowLogin">
          {{ $t("label_login_button") }}
        </p>
      </b-form>
    </b-col>
  </div>
</template>
<script>
export default {
  name: "Login",
  data: function () {
    return {
      infoError: false,
      username: "",
      password: "",
      error: "",
      usernameRecovery: "",
      showLogin: true,
    };
  },
  methods: {
    login: function () {
      this.infoError = false;
      const { username, password } = this;
      this.$store
        .dispatch("AUTH_REQUEST", { username, password })
        .then(() => {
          this.$router.push("/dashboard");
        })
        .catch((err) => {
          this.infoError = true; // TODO aplicar con estilos
          console.log(err);
          this.error = err.response.data.error.message;
        });
    },
    toggleShowLogin: function () {
      this.showLogin = !this.showLogin;
    },
  },
};
</script>
<style lang="scss" scoped>

@import "../../assets/css/variables.scss";

.login {
  .language-selector{
    align-items: right;
    margin-right: 10px;
  }
  .box {
    margin-top: -2.5vh;
    background-color: white;
    border: 1px solid $primary-color;
    border-radius: 10px;
    border-style: none;
    padding: 30px;
    box-shadow: -1px 1px 5px #c9c9c9;
  }
  .legend {
    color: $primary-color;
    font-size: 1rem;
    text-align: center;
  }
  h3 {
    color: $primary-color;
    font-size: 2rem;
    text-align: center;
    text-transform: uppercase;
  }
  .input-group{
    background-color: $header-accent;
  }
  .forgot {
    text-align: center;
    margin-top: 0.5rem;
    color: $secondary-color;
    cursor: pointer;
  }
}
</style>
